import { useEffect, useRef } from 'react';
import { perfMonitor } from '../utils/performanceMonitor';

export function usePerformanceTracking(componentName: string) {
  const renderCount = useRef(0);
  const mountTime = useRef(Date.now());
  
  useEffect(() => {
    renderCount.current += 1;
    perfMonitor.trackRender(componentName);
    
    // Track mount time in development
    if (process.env.NODE_ENV === 'development') {
      const renderTime = Date.now() - mountTime.current;
      console.log(`[RENDER] ${componentName} - Count: ${renderCount.current}, Time since mount: ${renderTime}ms`);
    }
  });

  // Return render count for debugging
  return {
    renderCount: renderCount.current,
    mountTime: mountTime.current
  };
}

// Hook for tracking API calls with automatic endpoint detection
export function useAPITracking() {
  const trackCall = (endpoint: string) => {
    perfMonitor.trackAPICall(endpoint);
  };

  return { trackCall };
}

// Hook for monitoring performance metrics
export function usePerformanceMetrics() {
  const getMetrics = () => perfMonitor.getMetrics();
  
  const onAlert = (callback: (type: string, data: any) => void) => {
    return perfMonitor.onAlert(callback);
  };

  return {
    getMetrics,
    onAlert,
    updateThresholds: perfMonitor.updateThresholds.bind(perfMonitor)
  };
} 